import Tooltip from 'tooltip.js';

$(document).on('click', '.js-popover-btn', function() {
    const $this = $(this);
    const $popover = $this.next();
    $('.js-popover').fadeOut();

    if (!$this.hasClass('in')) {
        $('.js-popover-btn').removeClass('in');
        $this.addClass('in');

        $popover
            .fadeIn()
            .find('textarea')
            .focus();
    } else {
        $('.js-popover-btn').removeClass('in');
    }
});

$(document).click(function(event) {
    const $target = $(event.target);

    if ($target.hasClass('js-popover') || $target.closest('.js-popover').length) {
        return;
    }
    if (!$target.closest('.js-popover-btn').length && !$target.hasClass('js-popover-btn')) {
        hidePopover();
    }
});

function hidePopover() {
    $('.js-popover').fadeOut();
    $('.js-popover-btn').removeClass('in');
}

// tooltip
const initTooltip = () => {
    $('.geography__map-point').each(function() {
        const $el = $(this);
        const text = $el.data('regions');

        new Tooltip($el[0], {
            placement: 'top',
            title: text,
            container: $('body')[0],
        });
    });
    $('.map-section__map-point').each(function() {
        const $el = $(this);
        const text = $el.data('tooltip');

        new Tooltip($el[0], {
            placement: 'top',
            title: text,
            container: $('body')[0],
        });
    });
    $('.js-tooltip').each(function() {
        const $el = $(this);
        const text = $el.data('tooltip');

        if (typeof text !== 'undefined' && !!text) {
            new Tooltip($el[0], {
                placement: 'top',
                html: true,
                title: text,
                container: $el.parent()[0],
            });
        }
    });
};

initTooltip();
NLMK.initTooltip = initTooltip;

export { initTooltip };



// WEBPACK FOOTER //
// ./js/main/module/popover/index.js